export class SupplierOtherCreditorTypes {
    static Supplier: string = "Supplier";
    static MfsAddOnCode: string = "'Other' Creditor";
}
